export default __webpack_public_path__ + "static/media/section5-pic1.143dcc7e.png";